export var font = {
    family: {
        glosa: 'Glosa, serif',
        proximaNova: 'ProximaNova, sans-serif',
    },
    weight: {
        bold: 700,
        semiBold: 600,
        normal: 400,
        light: 100,
    },
    size: {
        base: '16px',
        normal: '1rem',
        large: '1.125rem',
        tiny: '0.75rem',
    },
};
export var lineHeights = {
    base: '1.5rem',
};
export var colors = {
    lightGray: '#f5f5f5',
    gray2: '#aaaaaa',
    gray: '#cccccc',
    gray3: '#d8d8d8',
    gray4: '#dfe4e4',
    gray5: '#828282',
    darkGray: '#999999',
    lighterGray: '#555',
    darkGrayTurquoise: '#637877',
    lightBlack: '#111111',
    lighterBlack: '#555555',
    mediumBlack: '#222',
    primary: '#00c1b1',
    transparent: 'transparent',
    yellow: '#f2b134',
    planHeader: '#8fa8a6',
    white: '#ffffff',
    white2: '#fafafa',
    white3: '#e0e0e0',
    black: '#000000',
    green: '#4E9500',
    red: '#de2a2a',
    plainRed: '#FF303B',
    backgroundPrimary: '#f3f3f3',
    backgroundSecondary: '#dfe3e3',
    placeholder: '#777',
    pink: '#edd5db',
    backgroundYellow: '#ffedc3',
    coolCandy: '#edd5db',
    mint: '#96C8BE',
    midnight: '#153255',
    status: {
        normal: '#088587',
        success: '#4E9500',
        warning: '#F2B134',
        error: '#ED563B',
        info: '#088587',
    },
    statusTag: {
        completed: '#088587',
        important: '#ED563B',
        optional: '#F2b134',
        advertising: '#777777',
        comingSoon: '#777777',
        recommended: '#F28234',
        incompleted: '#777777',
        active: '#088587',
        inActive: '#777777',
        inProgress: '#4e9500',
    },
};
//# sourceMappingURL=index.js.map